import { Component } from '@angular/core';

@Component({
  templateUrl: './license.component.html'
})
export class LicenseComponent {

}



// WEBPACK FOOTER //
// ./src/app/license/license.component.ts